module.exports = __webpack_public_path__ + "static/img/6.2ed1210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/6.png
// module id = I5x9
// module chunks = 1